import React, { Component } from "react"
import { connect } from 'react-redux'
import { saveTransactionAction} from '../../redux/actions/MainAction'
import {  MessageText } from '../../configs'
import {setIsAcceptAction,setIsPoAcceptAction} from '../../redux/actions/ApproveAction'
class SubmitVerifyModal extends Component {


    constructor(props) {
        super(props)

        this.state = {
            ...props,
            message_to_committee:"",

        }
        this.handleChange = this.handleChange.bind(this)
    }
    handleChange(event){

        const name = event.target.name;
        let value = event.target.type === 'checkbox' ? (event.target.checked ? true : false) : event.target.value;
        this.setState({
            [name]: value
        })


    }

    handleSubmit(event)
    {
        let {message_to_committee} = this.state
        this.props.onHandleVerifySubmit(message_to_committee);
    }

    componentDidMount(){

    }

    getRpaShowState(){
        
        const {
            po_no,
            t_GR_ITEM,
            t_GR_ITEM_ACCOUNT_ASSIGNMENT
        } = this.props
        
        let is_rpa = true 

        let is_profit_segment = false
        let is_subcontracting = false
        let is_purchase_consumption = false 

        //Case : Profit segment
        // Item Assg. : J 
        // Item Cat. : ทุกค่า
        t_GR_ITEM.forEach(item => {
            if(item.a==="J" && (item.checked === '1' || item.checked === 1 || item.checked === true)){
                is_profit_segment = true
            }
        });
        
        t_GR_ITEM.forEach(item => {
            if(item.i==="L" && (item.checked === '1' || item.checked === 1 || item.checked === true)){
                is_subcontracting = true
            }
        });

        let is_f = false
        let is_multiple_account_assignment = false
        let is_contract= po_no && po_no.startsWith('41')
        
        t_GR_ITEM.forEach(item => {
            if(item.a==="F" && (item.checked === '1' || item.checked === 1 || item.checked === true)){
                is_f = true
            }
        });
        
        is_multiple_account_assignment = (t_GR_ITEM_ACCOUNT_ASSIGNMENT.length > 1);
        var key = ""
        t_GR_ITEM_ACCOUNT_ASSIGNMENT.forEach(item => {
            if(key!== item.item_no)
            {
                key = item.item_no
              is_multiple_account_assignment = false
            }
            else
            {
              is_multiple_account_assignment = true
              return
            }
            });
        is_purchase_consumption = is_contract && is_f &&is_multiple_account_assignment;

        is_rpa = is_rpa && !is_profit_segment && !is_subcontracting && !is_purchase_consumption
            
        return is_rpa
    }
    
    render() {
       
        const { transaction_no,mom_no,doc_no } = this.props
       const {message_to_committee} = this.state

        let is_rpa = this.getRpaShowState()
        var countCommitteeNotApprove = this.props.t_PO_COMMITTEE.filter(committee => committee.approve_status === 'N')

        let is_unanimous = (countCommitteeNotApprove.length>0)
        return (
            <div className="modal fade sp-modal rrs-modal" id="SubmitVerifyModal" tabIndex={-1} role="dialog" aria-labelledby="SubmitVerifyModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
                    <div className="modal-content">
                        <div className="modal-header bg-success">
                            <h5 className="modal-title" id="SubmitVerifyModalLabel">Success</h5>
                            {/* <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">×</span>
                            </button> */}
                        </div>
                        <div className="modal-body rrs-container">

                    <div className="rrs-detail2">
                            <div className="rrs-form-group-search">
                                <label htmlFor="verify_head" id="verify_head" className="rrs-form-group-search-label2">Verify สำเร็จ</label>
                                <br/><label htmlFor="mom_no" id="mom_no" className="rrs-form-group-search-label">เลขที่เอกสาร/ MOM Doc No. : {mom_no} </label>
                                { doc_no && ( 
                                    <>
                                        <br/><label htmlFor="doc_no" id="doc_no" className="rrs-form-group-search-label">เลขที่เอกสาร/ RRS Doc No. : {doc_no}</label>
                                    </>
                                )}
                                <br/><label htmlFor="search-purchase-num" className="rrs-form-group-search-label2">ข้อความส่งถึงคณะกรรมการตรวจรับ (ถ้ามี)</label>
                                <div className="row justify-content-center mx-0">
                                    <div className="rrs-detail-data">
                                    <textarea
                                            cols={80}
                                            rows={6}
                                            key={`delay_remark${transaction_no}`}
                                            name="message_to_committee"
                                            id="message_to_committee"
                                            className="form-control rrs-textarea"
                                             value={message_to_committee}
                                             onChange={this.handleChange} 
                                            maxLength="3000"
                                            placeholder="เช่น โปรดพิจารณาตรวจรับโดยเร็ว เนื่องจากต้องนำส่งเรื่องไปยังหน่วยงานบัญชีภายในวันที่ 31 ส.ค.64 มิฉะนั้น คณะกรรมการตรวจรับต้องจัดทำใบบันทึกนำส่งใบกำกับภาษี ล่าช้าและส่งมายังคุณ “ชื่อพนักงาน” )"
                                            />

                                    </div>
                                </div>
                            </div>
                            </div>                   
                                <div className="rrs-detail">    
                                    <div className="col-12 ">
                                        <a href="#" className="sp-btn-icon btn-ok" data-dismiss="modal" aria-label="Close"
                                            onClick={(event) => { this.handleSubmit(event)  }}  >
                                            <i className="icon btn-order-check-green" />
                                            <span className="sp-btn-icon-label3">{MessageText.APP.MSG_BOX_BUTTON_TEXT_OK}</span>
                                        </a>
                                    </div>                                   
                                </div>
                            
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    const { MainRedux} = state
    return {
      transaction: MainRedux.transaction,
      t_GR_ITEM: MainRedux.t_GR_ITEM,
      t_GR_ITEM_ACCOUNT_ASSIGNMENT: MainRedux.t_GR_ITEM_ACCOUNT_ASSIGNMENT,
      t_PO_COMMITTEE : MainRedux.t_PO_COMMITTEE,
      po_no: MainRedux.po_no,
    }
  }
  
  const mapDispatchToProps = dispatch => {
    return {
      //saveTransaction: (transaction) => dispatch(saveTransactionAction(transaction))
      setIsAccept:(isActive) => dispatch(setIsAcceptAction(isActive)),
      setIsPoAccept:(isActive) => dispatch(setIsPoAcceptAction(isActive)),
    }
  }
  
  export default connect(
    mapStateToProps,
    mapDispatchToProps
  )(SubmitVerifyModal)